import { EDLORDER } from '~/consts';

export default {
  data() {
    return {
      loading_buy: false,
      loading_get_detail: false,
      loading_get_list: false,
      loading_cancel: false,
      edlinvoice: null,
      edlorder: null,
      edlorders: [],
      dataProviderParams: null,
    }
  },

  methods: {
    async createOrder(group_ids) {
      this.loading_buy = true

      try {
        const { data } = await this.$axios.post(EDLORDER.CREATE, { group_ids })

        if (data.applicationSystem.code == 0) {
          this.loading_buy = false
          this.edlinvoice = data.data
          this.onCreateOrderSuccess()
        } else {
          this.onCreateOrderFailed(data.applicationSystem.message)
        }
      } catch (error) {
        this.onCreateOrderFailed('Terjadi kesalahan pada sistem. Silakan ulangi kembali beberapa saat lagi')
      }
    },

    onCreateOrderSuccess() {},

    onCreateOrderFailed(message) {
      toast.danger(message)
      this.loading_buy = false
    },

    async getDetail(id) {
      this.loading_get_detail = true

      try {
        const { data } = await this.$axios.get(EDLORDER.SHOW(id))

        setTimeout(() => {
          this.loading_get_detail = false
          if (data.applicationSystem.code == 0) {
            this.edlorder = data.data
            this.onGetDetailSuccess()
          } else {
            this.onGetDetailFail()
          }
        }, 1500);
      } catch (error) {
        setTimeout(() => {
          this.loading_get_detail = false
          this.onGetDetailFail()
        }, 2000);
      }
    },

    onGetDetailSuccess() {},

    onGetDetailFail() {},

    async getList(refresh) {
      this.loading_get_list = true

      if (refresh) {
        this.dataProviderParams.page['current'] = 1;
      }

      try {
        const { data } = await this.$axios.post(EDLORDER.LIST, { dataProvider: JSON.stringify(this.dataProviderParams) })

        if (data.applicationSystem.code == 0) {
          let edlordersTemp = data.data.data
          if (!refresh) {
            edlordersTemp = collect(this.edlorders).merge(data.data.data).toArray()
          }

          this.edlorders = edlordersTemp
          this.dataProviderParams = data.data.dataProvider
        }

        this.loading_get_list = false
      } catch (error) {
        this.loading_get_list = false
      }
    },

    onGetListSuccess() {},
    onGetListFail() {},

    async cancelOrder(id) {
      this.loading_cancel = true

      try {
        const { data } = await this.$axios.post(EDLORDER.CANCEL(id))

        this.loading_cancel = false
        if (data.applicationSystem.code == 0) {
          toast.success(data.applicationSystem.message)
          this.onCancelOrderSuccess()
        } else {
          toast.danger(data.applicationSystem.message)
          this.onCancelOrderFail()
        }
      } catch (error) {
        this.loading_cancel = false
        toast.danger('Terjadi kesalahan pada sistem. Silakan ulangi kembali beberapa saat lagi')
        this.onCancelOrderFail()
      }
    },

    onCancelOrderSuccess() {},
    onCancelOrderFail() {},
  }
}
